import { render, staticRenderFns } from "./eat_plan.vue?vue&type=template&id=6cd677a8&scoped=true&"
import script from "./eat_plan.vue?vue&type=script&lang=js&"
export * from "./eat_plan.vue?vue&type=script&lang=js&"
import style0 from "./eat_plan.vue?vue&type=style&index=0&id=6cd677a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd677a8",
  null
  
)

export default component.exports